import { memo, useCallback, useState } from "react";

import ProjectLabels from "./ProjectLabels";

import Button from "components/ui/ButtonNew";
import DashboardPanel from "components/ui/Dashboard";

import { projectReadOnlyEnabled } from "pages/utils";

import { PROJECT_LABELS } from "utils/constants";
import { hasAnyOfPermissions } from "utils/user";
import { USER_ACTIONS } from "utils/user/defines";

import { ProjectDashboardPanelProps } from "pages/ManageProject/ProjectionsContent/ProjectDashboard/types";

const ProjectLabelsPanel = memo(({ project }: ProjectDashboardPanelProps) => {
    const [isEditing, setIsEditing] = useState(false);

    const onChangeClick = useCallback(() => {
        setIsEditing(true);
    }, []);

    const onCancelClick = useCallback(() => {
        setIsEditing(false);
    }, []);

    const headerAction =
        !isEditing && !projectReadOnlyEnabled(project.projectState) && hasAnyOfPermissions([USER_ACTIONS.PROJECT_LABELS_EDIT]) ? (
            <Button variant="tertiary" padding="md" iconLeft="ui-pencil__edit__create_b_s" iconSize="sm" onClick={onChangeClick}>
                Change Project Labels
            </Button>
        ) : undefined;

    return (
        <DashboardPanel className="project-labels-panel" title="Labels" headerAction={headerAction} pageId={PROJECT_LABELS}>
            <ProjectLabels project={project} editing={isEditing} onEditCancel={onCancelClick} />
        </DashboardPanel>
    );
});

export default ProjectLabelsPanel;
